import { TranslationObject } from '@ngx-translate/core';

const nl: TranslationObject = {
  nl: 'Dutch',
  app: {
    test: 'Dit is een testlabel',
    title: 'SWD - Werkdiscipline',
    welcomeMessage: 'Welkom bij de SWD-webapplicatie',
    forms: {
      ok: 'Ok',
      cancel: 'Annuleer',
      create: 'Maak aan',
      continue: 'Doorgaan',
      labels: {
        businessUnit: 'Bedrijfseenheid',
        placeholderBusinessUnit: 'Selecteer een bedrijfseenheid',
        user: 'Gebruiker',
        name: 'Naam',
        description: 'Beschrijving',
        placeHolderDescription: 'Voer een beschrijving in',
        placeHolderReviewType: 'Selecteer een beoordelingssoort',
        mandatory: 'Verplicht',
      },
      unsavedChangesWarning:
        'Er zijn niet-opgeslagen wijzigingen gedetecteerd. Als u deze pagina verlaat, gaan de door u aangebrachte wijzigingen verloren.<br>Wilt u doorgaan?',
    },
    warnings: {
      removeOwnAdminRights: 'U heeft uw beheerdersrechten verwijderd. Vernieuw de webpagina om storingen te voorkomen.',

      removeOwnAccess: 'U heeft uw toegang verwijderd. Vernieuw de webpagina om storingen te voorkomen.',
    },
  },
  navigation: {
    startWorkDone: 'Observaties',
    category: 'Categorieën',
    businessUnits: 'Bedrijfseenheden',
    sysAdmins: 'Systeembeheerders',
    administration: 'Administration',
    users: 'Gebruikers',
    areas: 'Gebieden',
    errorReductionTools: 'Foutreductietools',
    nonBadgedPersons: 'Geobserveerde personen zonder badge',
  },
  startWorkDoneList: {
    title: 'Observaties',
    noStartWorkDone:
      'Selecteer een Bedrijfseenheid, Gebied, Subgebied, Categorie en Geobserveerde persoon om records weer te geven',
    emptyList: 'Geen Werkdiscipline-records gevonden voor de geselecteerde filters',
    id: 'ID',
    question: 'Controle',
    answer: 'Antwoord',
    score: 'Score',
    comment: 'Opmerking',
    errorReductionTool: 'Foutreductietool',
    updatedBy: 'Bijgewerkt door',
    updatedDate: 'Datum van bijwerking',
    createNewStartWorkDone: 'nieuw startwerk maken',
    reviewType: 'Beoordelingstype',
    area: 'Gebied',
    observationDate: 'Observatiedatum',
    subArea: 'Subgebied',
    category: 'Categorie',
    placeholderArea: 'Selecteer een gebied',
    placeholderSubArea: 'Selecteer een subgebied',
    placeholderCategory: 'Selecteer een categorie',
    addQuestion: 'Controle Toevoegen',
    description: 'Beschrijving',
    subSection: 'Subsectie',
    clearAnswer: 'Antwoord Wissen',
    deleteQuestion: 'Controle Verwijderen',
    deleteQuestionTitle: 'Controle Verwijderen',
    confirmDeleteQuestion:
      '<span>Weet u zeker dat u deze controle wilt verwijderen?</span><br><br><span><b>Controle:</b> {{ description }}</span>',
    editQuestion: 'Controle Bewerken',
    editQuestionHeader: 'Controle Bewerken',
    userSearch: 'Geobserveerde persoon',
    userSearchPlaceholder: 'Zoeken op naam of email...',
    supervisor: 'Supervisor',
    noSupervisor: 'Geen supervisor gevonden',
    nonBadgedPersonObserved: 'Geobserveerde persoon zonder badge',
    placeholderNonBadgedPersonObserved: 'Selecteer een persoon zonder badge',
    personSelectionConflict:
      'Slechts één van de volgende velden mag worden ingevuld: Geobserveerde persoon of Geobserveerde persoon zonder badge.',
    generateReport: 'Rapport Genereren',
    completeReview: 'Review Voltooien en Rapport Verzenden',
    generateReportInfoMessage: 'Uw rapport wordt gegenereerd en wordt automatisch gedownload. Dit kan even duren.',
    generateSuccessMessage: 'Rapport succesvol gegenereerd',
    reviewSuccessMessage: 'SWD observatierapport succesvol verzonden',
    sendEmail: 'Email Versturen',
    emailSuccessMessage: 'Email succesvol verzonden',
    emailErrorMessage: 'Fout bij verzenden van email',
    tableColumns: {
      businessUnit: 'Bedrijfseenheid',
      category: 'Categorie',
      subArea: 'Subgebied',
      area: 'Gebied',
      user: 'Geobserveerde persoon',
      nonBadgedPerson: 'Geobserveerde persoon zonder badge',
      supervisor: 'Supervisor',
      observationDate: 'Observatiedatum',
      totalScore: 'Totaalscore',
      createdBy: 'Waarnemer',
    },
    viewEdit: 'Bekijken / Bewerken',
  },
  startWorkDoneDetail: {
    title: 'Observatie',
    details: 'Algemene Informatie',
    notFound: 'Werkdiscipline record niet gevonden',
    accessDenied: 'U heeft geen toegang tot deze observatie.',
    saveSuccess: 'Record succesvol bijgewerkt',
    editInfo: 'Info Bewerken',
    saveInfo: 'Info Opslaan',
    errorReductionTools: 'Foutreductietools',
    noControls: 'Geen controles gevonden. Voeg eerst controles toe aan deze categorie.',
    totalScore: 'Totaalscore',
    deleteObservation: 'Observatie Verwijderen',
    deleteConfirmTitle: 'Observatie Verwijderen',
    deleteConfirmMessage:
      'Weet u zeker dat u deze observatie wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
    deleteSuccess: 'Observatie succesvol verwijderd',
    noObservationDate:
      'Er is geen Observatiedatum geselecteerd. Selecteer een datum voordat u deze beoordeling voltooit.',
  },
  categoryList: {
    title: 'Categorieën',
  },
  admin: {
    sysAdminList: {
      title: 'Systeembeheerders',
      addSysAdmin: 'systeembeheerder toevoegen',
      fullName: 'volledige naam',
      email: 'e-mail',
      dialogs: {
        removeAccessHeader: 'Bevestiging',
        removeAccessMessage:
          'Weet u zeker dat u de systeembeheerderstoegang voor [{{firstName}} {{lastName}}] wilt verwijderen?',
      },
    },
    businessUnitLists: {
      title: 'Bedrijfseenheden',
      addBusinessUnit: 'Bedrijfseenheid toevoegen',
      tableTitle: 'Bedrijfseenheid',
      noBusinessUnits: 'Geen bedrijfseenheden gevonden.',
      dialogs: {
        createHeader: 'Bedrijfseenheid aanmaken',
        namePlaceholder: 'Voer een naam in',
      },
    },
    businessUnitEdit: {
      title: 'Bewerk Bedrijfseenheid',
    },
    errorReductionTools: {
      title: 'Foutreductietools',
      addErt: 'foutreductietool toevoegen',
      tableTitle: 'foutreductietool',
      noErts: 'Geen foutreductietools gevonden.',
      dialogs: {
        createHeader: 'Foutreductietool aanmaken',
        editHeader: 'Foutreductietool bewerken',
        namePlaceholder: 'Voer een naam in',
        deleteTitle: 'Foutreductietool verwijderen',
        deleteMessage: 'Weet u zeker dat u de foutreductietool <strong>{{name}}</strong> wilt verwijderen?',
        deleteSuccess: 'Foutreductietool succesvol verwijderd.',
        deleteConflict:
          'Deze foutreductietool kan niet worden verwijderd omdat deze gekoppeld is aan een of meer controls.',
      },
    },
    nonBadgedPersons: {
      title: 'Geobserveerde personen zonder badge',
      addPerson: 'geobserveerde persoon zonder badge toevoegen',
      importPeople: 'gebruikers van vergunningen zonder badge importeren',
      noPeople: 'Geen personen zonder badge gevonden.',
      columns: {
        name: 'geobserveerde persoon zonder badge',
        supervisorEmail: 'e-mail supervisor',
        supervisorName: 'naam supervisor',
      },
      dialogs: {
        createHeader: 'Geobserveerde persoon zonder badge toevoegen',
        editHeader: 'Geobserveerde persoon zonder badge bewerken',
        nameLabel: 'Persoon zonder badge',
        nameRequired: 'Naam is verplicht',
        supervisorLabel: 'Supervisor',
        supervisorPlaceholder: 'Zoeken op naam of email...',
        supervisorRequired: 'E-mail is verplicht',
        deleteTitle: 'Persoon zonder badge verwijderen',
        deleteMessage: 'Weet u zeker dat u de persoon zonder badge <strong>{{name}}</strong> wilt verwijderen?',
        deleteSuccess: 'Persoon zonder badge succesvol verwijderd.',
        deleteConflict:
          'Deze persoon zonder badge kan niet worden verwijderd omdat deze aan een of meer observaties heeft deelgenomen.',
        importHeader: 'Geobserveerde personen zonder badge importeren',
        attachDocument: 'Document bijvoegen',
        uploadedOn: 'Geüpload op {{date}}',
        removeFile: 'Bestand verwijderen',
        invalidFile: 'Selecteer één Excel-bestand (.xlsx) van maximaal 5 MB.',
        importFailed: 'Er is niets geïmporteerd. Los deze fouten op en probeer het opnieuw:',
        importSuccess: 'Import voltooid. Geïmporteerd: {{imported}}. Duplicaten overgeslagen: {{skipped}}.',
      },
    },
    areas: {
      title: 'Gebieden',
      areasTitle: 'Gebieden',
      subAreasTitle: 'Subgebieden',
      addArea: 'Gebied toevoegen',
      addSubArea: 'Subgebied toevoegen',
      areaName: 'Naam',
      subAreaName: 'Subgebieden',
      category: 'Categorie',
      noAreas: 'Geen gebieden beschikbaar.',
      noSubAreas: 'Geen subgebieden beschikbaar.',
      selectAreaMessage: 'Selecteer een gebied om de subgebieden te beheren.',
      dialogs: {
        createAreaHeader: 'Gebied aanmaken',
        editAreaHeader: 'Gebied bewerken',
        createSubAreaHeader: 'Subgebied aanmaken',
        editSubAreaHeader: 'Subgebied bewerken',
        namePlaceholder: 'Voer een naam in',
        category: 'Categorie',
        categoryPlaceholder: 'Selecteer een categorie (optioneel)',
        deleteAreaTitle: 'Gebied verwijderen',
        deleteAreaMessage: 'Weet u zeker dat u het gebied <strong>{{name}}</strong> wilt verwijderen?',
        deleteAreaLinkedRecords:
          'Dit gebied kan niet worden verwijderd omdat er gekoppelde Werkdiscipline-records zijn.',
        deleteSubAreaTitle: 'Subgebied verwijderen',
        deleteSubAreaMessage: 'Weet u zeker dat u het subgebied <strong>{{name}}</strong> wilt verwijderen?',
        deleteSubAreaLinkedRecords:
          'Dit subgebied kan niet worden verwijderd omdat er gekoppelde Werkdiscipline-records zijn.',
      },
    },
  },
  user: {
    requestAccess: {
      title: 'Niet geregistreerd',
      forms: {
        submit: 'Verzoek Toegang',
      },
      dialogTitle: 'Verzoek Toegang',
      dialogSubtitle:
        'Je staat op het punt om toegang aan te vragen voor <strong>{{name}}</strong>, wil je verder gaan?',
      reloadWarning:
        'Als je deze pagina bezoekt maar al toegang hebt, klik dan op de volgende link om opnieuw te laden. Neem anders contact op met de ondersteuning.',
      reload: 'Opnieuw laden',
    },
    pendingAccess: {
      title: 'Hi, je Verzoek voor Toegang is in behandeling',
      reloadWarning:
        'Als je deze pagina bezoekt maar al toegang hebt, klik dan op de volgende link om opnieuw te laden. Neem anders contact op met de ondersteuning.',
      reload: 'Opnieuw laden',
    },
  },
  header: {
    logoAlt: 'CVX-logo',
    userAvatarAlt: 'Gebruikersavatar',
    unknownUser: 'Onbekend',
  },
  footer: {
    text: 'Chevron Corporation. Alle rechten voorbehouden.',
    version: 'SWD v{{ version }}',
  },
  category: {
    title: 'Categorieën',
    create: 'Erstellen',
    name: 'Name',
    description: 'Beschreibung',
    actions: 'Aktionen',
    edit: 'Bearbeiten',
    manage: 'Verwalten',
    delete: 'Löschen',
    confirmDelete:
      '<span>Sind Sie sicher, dass Sie diese Kategorie löschen möchten?</span><br><br><span>Name: {{ name }}<br>Beschreibung: {{ description }}</span>',
    noCategories: 'Keine Kategorien verfügbar.',
    titleCreate: 'Kategorie erstellen',
    createNew: 'Neu erstellen',
    selectPlaceholder: 'Wählen Sie eine Option aus...',
    titleEdit: 'Kategorie bearbeiten',
    titleDelete: 'Kategorie löschen',
    deletedSuccessfully: 'Kategorie erfolgreich gelöscht',
    importCategory: 'Kategorie importieren',
    importCategoryTitle: 'Kategorie importieren nach ',
    selectCategoryType: 'Kategorietyp auswählen',
    confirm: 'Bestätigen',
    importSuccessMessage: 'Kategorie erfolgreich importiert',
    manageControls: 'Controles beheren',
    noControls: 'Geen controles beschikbaar.',
    selectBusinessUnit: 'Selecteer een bedrijfseenheid om controles weer te geven',
    importCategoriesTitle: 'Categorieën importeren',
    import: 'Importeren',
  },
  common: {
    selectAnswer: 'Select answer',
    noAttempt: 'No Attempt',
    needsImprovement: 'Needs Improvement',
    meetsExpectations: 'Meets Expectations',
    exceedsExpectations: 'Exceed Expectations',
    save: 'Speichern',
    businessUnit: 'Geschäftseinheit',
    forbidActionErrorMessage: 'De gebruiker is niet gemachtigd om deze actie uit te voeren.',
    name: 'Name',
    code: 'Code',
    cancel: 'Stornieren',
    genericErrorMessage: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
    savedSuccessfully: 'Erfolgreich gespeichert',
    delete: 'Löschen',
    deletedSuccessfully: 'Erfolgreich gelöscht',
    edit: 'Bearbeiten',
    leaveWithOutSaving: 'Verlassen ohne zu speichern',
    language: 'Taal',
    view: 'Bekijken',
    back: 'Terug',
    createdBy: 'Aangemaakt door',
    updatedBy: 'Bijgewerkt door',
    updatedDate: 'Datum van bijwerking',
    errors: {
      failedToSubmit: 'Het verzenden van het antwoord is mislukt. Probeer het opnieuw.',
    },
  },
  serverError: {
    title: 'Server niet beschikbaar',
    message: 'Kan geen verbinding maken met de server. Controleer uw netwerkverbinding of probeer het later opnieuw.',
    returnHome: 'Terug naar startpagina',
  },
  pageNotFound: {
    title: 'Pagina niet gevonden',
    message: 'De pagina die u zoekt bestaat niet.',
    returnHome: 'Terug naar startpagina',
  },
  unauthorized: {
    title: 'Geen toegang',
    message: 'U heeft geen toestemming om deze pagina te openen.',
    returnHome: 'Terug naar startpagina',
  },

  categoryManage: {
    title: 'Beheer Inhoud van [{{ description }}]',
    questionsTitle: 'Controles',
    addQuestionAction: 'controle toevoegen',
    questionName: 'Controle',
    questionNamePlaceholder: 'Voer de tekst van de controle in',
    errorReductionTools: 'Foutreductietools',
    ertPlaceholder: 'Selecteer foutreductietools',
    noQuestions: 'Geen controles gevonden. Voeg een controle toe om te beginnen.',
    sectionsTitle: 'Onderdelen',
    subSectionsTitle: 'Subonderdelen',
    addSectionAction: 'sectie toevoegen',
    mandatoryLabel: 'Verplicht',
    createNewSubsectionAction: 'controlegroep toevoegen',
    emptySubSectionsMessage: `<p>Er is geen inhoud beschikbaar voor deze sectie.</p>
      <p>Voeg alstublieft een subsectie toe om te beginnen.</p>`,
    itemDescriptionTableHeader: 'Beschrijving',
    createNewItemAction: 'Controle Toevoegen',
    createSectionHeader: 'Maak Nieuw Onderdeel aan',
    editSectionHeader: 'Onderdeel Bewerken',
    confirmDeleteSection: 'Weet je zeker dat je de sectie <strong>{{description}}</strong> wilt verwijderen?',
    createSubSectionHeader: 'Controlegroep toevoegen',
    editSubSectionHeader: 'Bewerk Sub sectie',
    createQuestionTitle: 'Controle erstellen',
    ShouldAddCommentToQuestion:
      'Der Benutzer sollte zu jeder mit ‚N/A‘ beantworteten Kontrolle einen Kommentar hinzufügen',
    deleteQuestionTitle: 'Controle löschen',
    confirmDeleteQuestion:
      '<span>Sind Sie sicher, dass Sie diese Kontrolle löschen möchten?</span><br><br><span><b>Beschreibung:</b> {{ description }}</span>',
    confirmDeleteSubSection: 'Weet je zeker dat je de subsectie <strong>{{description}}</strong> wilt verwijderen?',
    deleteSectionHeader: 'Onderdeel Verwijderen',
    deleteSubSectionHeader: 'Subsectie Verwijderen',
    editQuestionTitle: 'Controle bearbeiten',
    defaultSubSectionName: 'Controles',
  },
  paginator: {
    previous: 'Vorige',
    next: 'Volgende',
    currentPageReport: '{{currentInitialRow}} - {{currentLastRow}} van {{totalRecords}}',
  },
  usersList: {
    title: 'Gebruikers',
    forms: {
      displayInactiveUsers: 'inactieve gebruikers weergeven',
    },
    actions: {
      addNewUser: 'Nieuwe gebruiker toevoegen',
      grantAccess: 'toegang verlenen',
    },
    table: {
      fullName: 'volledige naam',
      email: 'e-mail',
      admin: 'beheerder',
    },
    noUsers: 'Geen gebruikers beschikbaar',

    dialogs: {
      removeAccessHeader: 'Bevestiging',
      removeAccessMessage: 'Weet u zeker dat u de toegang wilt verwijderen voor: [{{fullName}}]?',
    },
  },
  actionItems: {
    title: 'Actie-items',
    addActionItem: 'actie-item toevoegen',
    actionTitle: 'Titel',
    assignee: 'Toegewezen persoon',
    date: 'Datum',
    id: 'ID',
    comment: 'Opmerking',
    priority: 'Prioriteit',
    dialogs: {
      configureActionItem: 'Configureer Actiepunt',
      configureComment: 'Opmerking',
      deleteActionItemHeader: 'Wis Actiepunt',
      deleteActionItemMessage: 'Weet je zeker dat je deze actie wilt uitvoeren?',
    },
  },
  comments: {
    title: 'Commentaar',
    addComment: 'commentaar toevoegen',
    noComments: 'Geen opmerkingen',
    dialogs: {
      configureComment: 'Opmerking',

      deleteCommentHeader: 'Commentaar verwijderen',
      deleteCommentMessage: 'Weet je zeker dat je deze actie wilt uitvoeren?',
    },
    comment: 'Opmerking',
    instructions: {
      title: 'Opmerkingen moeten het volgende bevatten:',
      observed: 'Wat is waargenomen',
      coaching: 'Welke begeleiding werd gegeven',
      action: 'Welke actie is ondernomen om problemen op te lossen',
      feedback: 'Welke positieve feedback werd gegeven voor het overstijgen van verwachtingen',
    },
  },
  features: {
    startWorkDone: {
      labels: {
        observationComment: 'Observatiecommentaar',
      },
      placeholders: {
        enterComment: 'Voer uw coachingfeedback of context voor dit antwoord in...',
      },
      messages: {
        responseSubmitted: 'Antwoord succesvol verzonden',
        commentRequired: 'Een opmerking is vereist voor dit antwoordtype',
      },
      responseAnswers: {
        noAttempt: 'Geen Poging',
        needsImprovement: 'Moet Verbeterd Worden',
        meetsExpectations: 'Voldoet aan Verwachtingen',
        exceedsExpectations: 'Overschrijdt Verwachtingen',
        notApplicable: 'Niet van Toepassing',
      },
    },
  },
};
export default nl;
